import request from'@/utils/request.js'
export default{
    QueryParameterItem(data) {
        return request({
            url: '/Parameter/QueryParameterItem',
            method: 'post',
            data
        })
    }    
}